import { render, staticRenderFns } from "./CompaniesSection.vue?vue&type=template&id=6b43db6d&scoped=true"
import script from "./CompaniesSection.ts?vue&type=script&lang=ts&external"
export * from "./CompaniesSection.ts?vue&type=script&lang=ts&external"
import style0 from "./CompaniesSection.vue?vue&type=style&index=0&id=6b43db6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b43db6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b43db6d')) {
      api.createRecord('6b43db6d', component.options)
    } else {
      api.reload('6b43db6d', component.options)
    }
    module.hot.accept("./CompaniesSection.vue?vue&type=template&id=6b43db6d&scoped=true", function () {
      api.rerender('6b43db6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/details/CompaniesSection/CompaniesSection.vue"
export default component.exports